// extracted by mini-css-extract-plugin
export default {"uu_fr":"uu_fr__hsBq2","uu":"uu__8NlEN","imgfr":"imgfr__kzzp-","img_name":"img_name__zFmuB","img_position":"img_position__3qxlV","pltxt":"pltxt__NhOEy"};